module.exports = __webpack_public_path__ + "static/img/customer-service.9cc72ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/customer-service.png
// module id = 16J9
// module chunks = 0